export { default as UICalendarIcon } from './calendar.vue'
export { default as UIListIcon } from './list.vue'
export { default as UIChevronRightIocn } from './chevron-right.vue'
export { default as UIChevronLeftIocn } from './chevron-left.vue'



// WEBPACK FOOTER //
// ./src/templates/pages/events/components/icons/index.js